import React, { Component } from "react";
import axios from "axios";
import { http } from "../modules/api";

import AiRpSignupOnboarding from "./AiRpSignupOnboarding";
import AiRpInstalling from "./AiRpInstalling";
import AiRpFreeTrial from "./AiRpFreeTrial";
import AiRpTrialEnded from "./AiRpTrialEnded";
import AiRpMainDashboard from "./AiRpMainDashboard";

class AiRpHomeContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      aiRpState: null,
      loading: true,
      errorMessage: "",
    };

    this.loadAiRpState = this.loadAiRpState.bind(this);
  }

  componentDidMount() {
    this.loadAiRpState();
  }

  async loadAiRpState() {
    try {
      this.setState({
        loading: true,
        errorMessage: "",
      });

      const response = await http.get("/rest/shop/ai/rp/state");

      this.setState({
        aiRpState: response.data || {},
      });
    } catch (error) {
      console.error("AI 추천 상태 조회 실패", error);

      this.setState({
        errorMessage: "AI 추천 상태를 불러오지 못했습니다.",
      });
    } finally {
      this.setState({
        loading: false,
      });
    }
  }

  toBool(value) {
    if (value === true || value === 1) {
      return true;
    }

    const strValue = String(value || "").toUpperCase();
    return strValue === "Y" || strValue === "TRUE" || strValue === "1";
  }

  getAiRpViewType(state) {
    const completedStep = Number(state.completed_step || state.current_step || 1);
    const freeOrderState = state.free_order_state || {};

    const paymentYn = state.payment_yn || freeOrderState.payment_yn || "N";
    const freeTrialFinishedYn = state.free_trial_finished_yn || state.is_finish || freeOrderState.is_finish || "N";
    const aiRpExpiredType = state.ai_rp_expired_type || freeOrderState.ai_rp_expired_type || "";

    // return "TRIAL_ENDED";

    if (
      aiRpExpiredType === "FREE_TRIAL_EXPIRED" ||
      aiRpExpiredType === "PAYMENT_EXPIRED"
    ) {
      return "TRIAL_ENDED";
    }

    if (paymentYn === "Y" || completedStep >= 5) {
      return "DASHBOARD";
    }

    if (completedStep >= 4 && this.toBool(freeTrialFinishedYn)) {
      return "TRIAL_ENDED";
    }

    if (completedStep >= 4) {
      return "FREE_TRIAL";
    }

    if (completedStep >= 3) {
      return "INSTALLING";
    }

    return "SIGNUP_ONBOARDING";
  }

  render() {
    const { aiRpState, loading, errorMessage } = this.state;

    if (loading) {
      // return <div style={{ padding: "24px" }}>로딩 중입니다.</div>;
      return <></>;
    }

    if (errorMessage) {
      return <div style={{ padding: "24px" }}>{errorMessage}</div>;
    }

    const state = aiRpState || {};
    const freeOrderState = state.free_order_state || {};
    const expiredType = state.ai_rp_expired_type || freeOrderState.ai_rp_expired_type || "";
    const targetviewInstallYn = state.targetview_install_yn || freeOrderState.targetview_install_yn || "N";

    const viewType = this.getAiRpViewType(state);

    switch (viewType) {
      case "DASHBOARD":
        return <AiRpMainDashboard />;
      case "TRIAL_ENDED":
        return (
          <AiRpTrialEnded
            expiredType={expiredType}
            freeOrderState={freeOrderState}
          />
        );
      case "FREE_TRIAL":
        return <AiRpFreeTrial />;
      case "INSTALLING":
        return <AiRpInstalling targetviewInstallYn={targetviewInstallYn} />;
      default:
        return <AiRpSignupOnboarding />;
    }
  }
}

export default AiRpHomeContainer;